import React from "react";
import Autocomplete from "react-google-autocomplete";
import { GOOGLE_API } from "../../../store/utils";
import "./LocationInput.css";
export interface LocationInputProps {
  options?: google.maps.places.AutocompleteOptions;
  onPlaceSelected: (location: google.maps.places.PlaceResult) => void;
  defaultValue?: string;
  placeholder?: string;
  showBorder?: boolean;
  customClass?: string;
  onClearValue?: () => void;
}

export const LocationInput = ({
  onPlaceSelected,
  options = {
    types: ["address"],
  },
  defaultValue,
  placeholder = "Enter a location",
  customClass = "location-input",
  showBorder = false,
  onClearValue,
}: LocationInputProps) => {
  const [active, setActive] = React.useState(false);
  const customStyle = showBorder ? {} : { border: "none" };

  return (
    <Autocomplete
      style={customStyle}
      onBlur={(e) => {
        if (!e.target.value) {
          onClearValue?.();
        }
        setActive(false);
      }}
      onFocus={() => {
        setActive(true);
      }}
      defaultValue={defaultValue}
      className={customClass}
      options={options}
      apiKey={GOOGLE_API}
      onPlaceSelected={onPlaceSelected}
      placeholder={active ? "Start typing an address" : placeholder}
    />
  );
};
